import { Flex, Image, Link } from "@theme/components";

import { getBlogSvgUrl } from "@theme/utils/images";

import type { NavCountriesInterface } from "@theme/types";

export const FooterCountrySelector = ({
  countries,
  isBlog,
}: {
  countries: NavCountriesInterface[];
  isBlog: boolean;
}) => (
  <Flex
    sx={{
      flexDirection: ["column", null, "row"],
      justifyContent: ["flex-start", null, "center"],
      alignItems: "center",
      flexWrap: "wrap",
      pb: "s200",
      px: "s800",
      maxWidth: 800,
      mx: "auto",
    }}
  >
    {countries.map((country) => {
      const { displayName, svgSrc, baseUrl } = country;

      return (
        <Link
          href={`${baseUrl}/?redirect=1`}
          key={displayName}
          variant="box"
          aria-label={`Visit ${displayName} site`}
          sx={{
            display: "flex",
            alignItems: "center",
            px: "s300",
            py: "s200",
            fontSize: "fs12",
            color: "textLevel3",
            ":hover": {
              color: "goldPrimary",
            },
            "> span": {
              justifyContent: ["flex-start", null, null, "center"],
            },
          }}
        >
          <Image
            src={getBlogSvgUrl(svgSrc, isBlog)}
            alt=""
            sx={{ mr: "s300", width: 20, height: "auto" }}
          />
          {displayName}
        </Link>
      );
    })}
  </Flex>
);
